<template>
	<span v-if="predefinedValue === 'irrelevant'">Übereinstimmung</span>
	<span v-else-if="predefinedValue === 'none'">Keine</span>
	<span v-else-if="predefinedValue === 'wanted'">Erwünscht</span>
	<span v-else-if="predefinedValue === 'unwanted'">Nicht erwünscht</span>
	<span v-else-if="predefinedValue === 'noneMatching'">Keine Übereinstimmung</span>
	<span v-else-if="predefinedValue === 'yes'">Übereinstimmung</span>
	<span v-else-if="predefinedValue === 'no'">Keine Übereinstimmung</span>
	<span v-else-if="predefinedValue === 'noneNecessary'">Keine nötig</span>
</template>

<script>
export default {

	props: {
		predefinedValue: {
			type: String,
			required: true,
		},
	},
}
</script>
